import { buildAroValidationContext } from './aroValidationContext'
import { buildMaxCharRule } from './validationRuleBuilders'

/**
 * Builds the Taxable Accounts validation context by extending the shared
 * ARO base context with taxable-accounts-specific field rules.
 *
 * Shared fields (recordkeeper, tpa, planSponsor, planName, planEin, etc.) are inherited
 * from buildAroValidationContext unchanged. Taxable-accounts-specific fields
 * (countryCode, taxableAmount) are added here. dateOfOriginalDistribution validation
 * is procedural and lives in the pure-validator functions in ParticipantsDataFormatting.
 *
 * @param {string} userAudience - e.g. 'Recordkeeper', 'TPA'
 * @returns {object} Validation context for Taxable Accounts listeners and pure validators
 */
export function buildTaxableAccountsValidationContext(userAudience) {
  const base = buildAroValidationContext(userAudience)

  return {
    // ── All shared ARO fields (recordkeeper, tpa, planSponsor, planName, planEin,
    //    planNumber, planIdNumber, firstName, middleName, lastName, addressLine1,
    //    addressLine2, city, ssn, emailAddress, audience flags,
    //    and pure-validator formats: ssnFormat, dobFormat, zipCodeFormat) ────────
    ...base,

    // ── Taxable Accounts-specific field rules ──────────────────────────────────
    countryCode: {
      maxChar: buildMaxCharRule(2),
    },
    taxableAmount: {
      maxChar: buildMaxCharRule(14),
      invalidAmount: {
        error: 'Taxable amount should not be zero',
      },
    },
  }
}
